/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Header_Watch_NowInputs */

const de_commons_header_watch_now = /** @type {(inputs: Commons_Header_Watch_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt Fernsehen`)
};

/** @type {(inputs: Commons_Header_Watch_NowInputs) => LocalizedString} */
const en_commons_header_watch_now = de_commons_header_watch_now;

/**

* @param {Commons_Header_Watch_NowInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_header_watch_now = /** @type {((inputs?: Commons_Header_Watch_NowInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Header_Watch_NowInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_header_watch_now(inputs)
	return en_commons_header_watch_now(inputs)
});